export var ComplianceProfileCommentForWarning;
(function (ComplianceProfileCommentForWarning) {
    ComplianceProfileCommentForWarning["REQUIRED"] = "Required";
    ComplianceProfileCommentForWarning["OPTIONAL"] = "Optional";
    ComplianceProfileCommentForWarning["NA"] = "N/A";
})(ComplianceProfileCommentForWarning || (ComplianceProfileCommentForWarning = {}));
//# sourceMappingURL=ComplianceProfileCommentForWarning.js.map